import Link from 'next/link';
import { FC, ReactNode } from 'react';

import { sanitizeUrl } from '@/helpers/storyblokLink';

export interface StoryblokLinkProps {
  link: any;
  passHref?: boolean;
  children?: ReactNode;
  props?: any;
}

const StoryblokLink: FC<StoryblokLinkProps> = ({
  link,
  passHref = false,
  children,
  ...props
}) => {
  if (link?.linktype === 'story') {
    if (link?.anchor) {
      return (
        <Link
          href={sanitizeUrl(`/${link.story?.full_slug}#${link.anchor}`)}
          passHref={passHref}
          {...props}
        >
          <>{children || link.story?.name}</>
        </Link>
      );
    }

    if (!link.story?.full_slug && link?.cached_url && link?.url === '') {
      return (
        <Link
          href={sanitizeUrl(`/${link.cached_url}`)}
          passHref={passHref}
          {...props}
        >
          <> {children || link.story?.name}</>
        </Link>
      );
    }

    return (
      <Link
        href={sanitizeUrl(`/${link.story?.full_slug}`)}
        passHref={passHref}
        {...props}
      >
        <> {children || link.story?.name}</>
      </Link>
    );
  }

  if (link?.linktype === 'url') {
    return (
      <Link
        href={link.url}
        target="_blank"
        rel="noreferrer"
        passHref={passHref}
        {...props}
      >
        <>{children || link.url}</>
      </Link>
    );
  }

  if (link?.linktype === 'email') {
    return (
      <a href={`mailto:${link.email}`} {...props}>
        {children || link.email}
      </a>
    );
  }

  if (link?.linktype === 'asset') {
    return (
      <a href={link.url} target="_blank" rel="noreferrer" {...props}>
        {children || link.url.replace(/^.*[\\/]/, '')}
      </a>
    );
  }

  return <>{'empty'}</>;
};

export default StoryblokLink;
